/* The Future Files — archive.org audio host resolver + fallback (2026-09-22)
 *
 * Root cause of "episodes do not play": every episode URL points at
 * https://archive.org/download/<item>/... which is a redirector. For this item
 * the redirector sends requests to an "alternate location" mirror
 * (dn721704.ca.archive.org) that answers HTTP 500 for every file, and the d2
 * primary (ia801602) accepts connections but streams nothing. Only the d1
 * primary (ia601602.us.archive.org, /15/items/...) actually serves the files,
 * and even it needs ~10-20 s before the first byte.
 *
 * Fix: resolve the item's primary servers from the public metadata API (cached
 * 6 h in localStorage, hard-coded default), health-probe them once per session
 * with a tiny ranged fetch and order by first-byte latency, rewrite every audio
 * URL to the best host, and if the element still errors or stalls, hop through
 * the remaining candidates (the redirector last).
 */
(function () {
  'use strict';
  var ITEM = 'toxictethers-cum-town-archive';
  var DL = 'https://archive.org/download/' + ITEM + '/';
  var KEY = 'tff_ia_hosts_v2';
  var TTL = 6 * 3600 * 1000;
  var PROBE_FILE = 'Cum%20Town%20Archive/1%29%20Cum%20Town%20Archive/01%20-%20Ep.%201%20-%20The%20Original%20Cum%20Boys.mp3';
  var DEFAULT = { dir: '/15/items/' + ITEM, hosts: ['ia601602.us.archive.org', 'ia801602.us.archive.org'] };
  var STALL_MS = 30000; // the good host needs ~10-20 s to start the body; be patient before hopping

  var state = DEFAULT;
  try {
    var cached = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (cached && cached.dir && cached.hosts && cached.hosts.length && (Date.now() - (cached.ts || 0)) < TTL) state = cached;
  } catch (e) {}
  var order = null; // probe-ranked host list for this session

  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  function refresh() {
    try {
      var c = new AbortController();
      var to = setTimeout(function () { c.abort(); }, 8000);
      return fetch('https://archive.org/metadata/' + ITEM + '?fields=server,dir,d1,d2,workable_servers', { signal: c.signal })
        .then(function (r) { return r.json(); })
        .then(function (m) {
          clearTimeout(to);
          if (!m || !m.dir) return;
          var hosts = [];
          // d1 first: it is the host that has actually been streaming; the "server" field flips between d1/d2.
          [m.d1, m.d2, m.server].concat(m.workable_servers || []).forEach(function (h) { if (h && hosts.indexOf(h) < 0) hosts.push(h); });
          if (!hosts.length) return;
          state = { dir: m.dir, hosts: hosts, ts: Date.now(), order: state.order };
          save();
        })
        .catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  function probe() {
    var results = [];
    var ps = state.hosts.map(function (h) {
      var url = 'https://' + h + state.dir + '/' + PROBE_FILE;
      var t0 = performance.now();
      var c = new AbortController();
      var to = setTimeout(function () { c.abort(); }, 15000);
      return fetch(url, { headers: { Range: 'bytes=0-1023' }, signal: c.signal, cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.arrayBuffer(); })
        .then(function (b) { clearTimeout(to); if (b.byteLength > 0) results.push({ h: h, ms: performance.now() - t0 }); })
        .catch(function () { clearTimeout(to); });
    });
    return Promise.all(ps).then(function () {
      if (!results.length) return;
      results.sort(function (a, b) { return a.ms - b.ms; });
      order = results.map(function (r) { return r.h; }).concat(state.hosts.filter(function (h) { return !results.some(function (r) { return r.h === h; }); }));
      state.order = order; state.orderTs = Date.now(); save();
      console.info('[tff-audio] host ranking', results.map(function (r) { return r.h + ' ' + Math.round(r.ms) + 'ms'; }).join(', '));
    });
  }

  // Use the cached ranking immediately (if <6h old), and re-probe in the background once per page load.
  if (state.order && state.order.length && (Date.now() - (state.orderTs || 0)) < TTL) order = state.order.slice();
  ((!state.ts || (Date.now() - state.ts) > TTL) ? refresh() : Promise.resolve()).then(probe);

  function hostList() {
    var out = [];
    (order || []).concat(state.hosts || []).forEach(function (h) { if (h && out.indexOf(h) < 0) out.push(h); });
    return out;
  }

  function candidates(url) {
    if (typeof url !== 'string' || url.indexOf(DL) !== 0) return [url];
    var path = url.slice(DL.length);
    var out = hostList().map(function (h) { return 'https://' + h + state.dir + '/' + path; });
    out.push(url); // the redirector, last resort
    return out;
  }

  var current = { orig: null, cands: [], idx: 0 };

  window.ffAudioCandidates = candidates;
  window.ffAudioMatches = function (currentSrc, url) { return !!currentSrc && candidates(url).indexOf(currentSrc) >= 0; };
  window.ffAudioUrl = function (url) {
    var c = candidates(url);
    current = { orig: url, cands: c, idx: 0 };
    return c[0];
  };

  function attach() {
    var p = document.getElementById('audioElement');
    if (!p || p._ffAudioAttached) return;
    p._ffAudioAttached = true;
    try { p.preload = 'auto'; } catch (e) {}
    var stallTimer = null;

    function clearStall() { if (stallTimer) { clearTimeout(stallTimer); stallTimer = null; } }
    function hop(reason) {
      clearStall();
      if (!current.cands.length || current.idx >= current.cands.length - 1) return false;
      var wasPlaying = !p.paused;
      var t = p.currentTime || 0;
      current.idx++;
      var next = current.cands[current.idx];
      console.warn('[tff-audio] ' + reason + ' on ' + (p.currentSrc || p.src) + ' -> trying ' + next);
      p.src = next;
      try { p.load(); } catch (e) {}
      if (t > 0) p.addEventListener('loadedmetadata', function once() { p.removeEventListener('loadedmetadata', once); try { p.currentTime = t; } catch (e) {} });
      if (wasPlaying) { var pr = p.play(); if (pr && pr.catch) pr.catch(function () {}); }
      return true;
    }
    function armStall() {
      clearStall();
      stallTimer = setTimeout(function () {
        if (p.readyState < 2 && p.src && current.cands.indexOf(p.src) >= 0) hop('no data after ' + (STALL_MS / 1000) + 's');
      }, STALL_MS);
    }
    p.addEventListener('loadstart', function () {
      if (p.src && current.cands.indexOf(p.src) >= 0) armStall();
    });
    p.addEventListener('loadeddata', clearStall);
    p.addEventListener('canplay', clearStall);
    p.addEventListener('playing', clearStall);
    p.addEventListener('emptied', clearStall);
    p.addEventListener('error', function () {
      var code = p.error && p.error.code;
      if (code === 1) return; // aborted by us
      if (!p.src || p.src === window.location.href || current.cands.indexOf(p.src) < 0) { clearStall(); return; } // src cleared (stop/reset) or not ours
      if (!hop('media error ' + code)) console.error('[tff-audio] all hosts failed for', current.orig);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach); else attach();
})();
